import React, { useState, useEffect } from 'react';
import { getUsuarios, createUsuario, toggleUsuario } from '../services/api';

function Usuarios() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState({ nombre: '', email: '', password: '', rol: 'empleado' });

  const roles = { superadmin: 'Super Admin', admin: 'Administrador', empleado: 'Empleado' };

  useEffect(() => { cargar(); }, []);

  const cargar = () => {
    getUsuarios().then(res => { setUsuarios(res.data); setLoading(false); }).catch(() => setLoading(false));
  };

  const guardar = async () => {
    if (!form.nombre || !form.email || !form.password) { setError('Todos los campos son requeridos'); return; }
    try {
      await createUsuario(form);
      setModal(false); cargar();
    } catch { setError('Error al crear usuario.'); }
  };

  const toggle = async (id) => {
    try { await toggleUsuario(id); cargar(); } catch {}
  };

  const badgeRol = (rol) => {
    const map = { superadmin: { bg: '#fee2e2', color: '#cc0000' }, admin: { bg: '#dbeafe', color: '#0d2461' }, empleado: { bg: '#f1f5f9', color: '#64748b' } };
    const s = map[rol] || map.empleado;
    return { background: s.bg, color: s.color, padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 600 };
  };

  if (loading) return <div style={{ textAlign: 'center', padding: 60, color: '#64748b' }}>Cargando...</div>;

  return (
    <div>
      <div style={{ background: 'white', borderRadius: 12, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
        <div style={{ padding: '18px 22px', borderBottom: '1px solid #f1f5f9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3 style={{ margin: 0, fontSize: 15, fontWeight: 600 }}>Usuarios ({usuarios.length})</h3>
          <button onClick={() => { setForm({ nombre: '', email: '', password: '', rol: 'empleado' }); setError(''); setModal(true); }}
            style={{ padding: '8px 16px', background: '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>
            + Nuevo Usuario
          </button>
        </div>
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                {['Nombre', 'Email', 'Rol', 'Estado', 'Acciones'].map(h => (
                  <th key={h} style={{ padding: '11px 16px', textAlign: 'left', fontSize: 12, fontWeight: 600, color: '#64748b', textTransform: 'uppercase', background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {usuarios.map(u => (
                <tr key={u.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                  <td style={{ padding: '13px 16px', fontSize: 14, fontWeight: 600 }}>{u.nombre}</td>
                  <td style={{ padding: '13px 16px', fontSize: 14, color: '#64748b' }}>{u.email}</td>
                  <td style={{ padding: '13px 16px' }}><span style={badgeRol(u.rol)}>{roles[u.rol]}</span></td>
                  <td style={{ padding: '13px 16px' }}>
                    <span style={{ background: u.activo ? '#dcfce7' : '#fee2e2', color: u.activo ? '#16a34a' : '#cc0000', padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 600 }}>
                      {u.activo ? 'Activo' : 'Inactivo'}
                    </span>
                  </td>
                  <td style={{ padding: '13px 16px' }}>
                    <button onClick={() => toggle(u.id)}
                      style={{ padding: '6px 12px', background: '#f1f5f9', border: 'none', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>
                      {u.activo ? '🔒 Desactivar' : '🔓 Activar'}
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Modal */}
      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div style={{ background: 'white', borderRadius: 16, width: '100%', maxWidth: 480, boxShadow: '0 25px 50px rgba(0,0,0,0.25)' }}>
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #e2e8f0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h2 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: '#0d2461' }}>Nuevo Usuario</h2>
              <button onClick={() => setModal(false)} style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: '#94a3b8' }}>×</button>
            </div>
            <div style={{ padding: 24 }}>
              {error && <div style={{ background: '#fee2e2', color: '#cc0000', padding: '10px 14px', borderRadius: 8, fontSize: 13, marginBottom: 16 }}>⚠️ {error}</div>}
              {[
                { field: 'nombre', label: 'Nombre', placeholder: 'Nombre completo' },
                { field: 'email', label: 'Email', placeholder: 'usuario@embarque.com', type: 'email' },
                { field: 'password', label: 'Contraseña', placeholder: '••••••••', type: 'password' },
              ].map(({ field, label, placeholder, type = 'text' }) => (
                <div key={field} style={{ marginBottom: 12 }}>
                  <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase' }}>{label}</label>
                  <input type={type} placeholder={placeholder} value={form[field]}
                    onChange={e => setForm({ ...form, [field]: e.target.value })}
                    style={{ width: '100%', marginTop: 5, padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none', boxSizing: 'border-box' }} />
                </div>
              ))}
              <div>
                <label style={{ fontSize: 12, fontWeight: 600, color: '#475569', textTransform: 'uppercase' }}>Rol</label>
                <select value={form.rol} onChange={e => setForm({ ...form, rol: e.target.value })}
                  style={{ width: '100%', marginTop: 5, padding: '9px 12px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, fontFamily: 'inherit', outline: 'none' }}>
                  <option value="empleado">Empleado</option>
                  <option value="admin">Administrador</option>
                  <option value="superadmin">Super Admin</option>
                </select>
              </div>
            </div>
            <div style={{ padding: '16px 24px', borderTop: '1px solid #e2e8f0', display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
              <button onClick={() => setModal(false)} style={{ padding: '9px 18px', background: 'white', color: '#0d2461', border: '1.5px solid #e2e8f0', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Cancelar</button>
              <button onClick={guardar} style={{ padding: '9px 18px', background: '#0d2461', color: 'white', border: 'none', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer', fontFamily: 'inherit' }}>Crear Usuario</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Usuarios;